// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CaretUp: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.75 7.465">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="M.293 5.879 6.23.289A.844.844 0 0 1 6.875 0c.23 0 .464.085.645.256l5.937 5.59a.938.938 0 0 1-1.29 1.362L6.876 2.193 1.582 7.208a.937.937 0 0 1-1.326-.036c-.355-.34-.34-.934.037-1.293Z"
            />
        </svg>
    );
};

export default React.memo(CaretUp);
